import { motion } from "framer-motion";
import styles from "./css/Question.module.css";
import { pageVariants, pageTransition, btnHover, btnTap } from "../utils/animations";

const Question02 = ({ setHandleEvent, setAvance, referencedByApp }) => {

	const handleEvent = (value) => {
		referencedByApp ? setAvance(4) : setAvance(3);
		setHandleEvent(prevState => ({ ...prevState, value02: value }));
	};

	return (
		<motion.div
			className={styles.containerQuestion}
			variants={pageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={pageTransition}
		>
			<div className={styles.titleQuestion}>
				¿Las indicaciones proporcionadas por la recepcionista fueron claras?
			</div>
			<div className={styles.containerOptions}>
				<motion.div className={styles.controlButton} onClick={() => handleEvent(1)} whileHover={btnHover} whileTap={btnTap}>
					Sí
				</motion.div>
				<motion.div className={styles.controlButton} onClick={() => handleEvent(0)} whileHover={btnHover} whileTap={btnTap}>
					No
				</motion.div>
			</div>
		</motion.div>
	);
};

export default Question02;
